import { useMemo } from "react";
import katex from "katex";
import "katex/dist/katex.min.css";

type MathTextProps = {
  latex: string;
  className?: string;
  displayMode?: boolean;
};

export function MathText({ latex, className, displayMode = false }: MathTextProps) {
  const html = useMemo(
    () =>
      katex.renderToString(latex, {
        throwOnError: false,
        displayMode,
        strict: "ignore",
      }),
    [displayMode, latex],
  );

  return <span className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}
